module.exports = __webpack_public_path__ + "static/logo-90f901074908eac1a98a7c8513198857.svg";